module.exports = __webpack_public_path__ + "static/media/details-11-image-2.613aa7da.jpg";